'use client';

import { useTranslations } from 'next-intl';
import { CheckCircle2, FileDown } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface CompletionScreenProps {
  email: string;
  donationId: string | null;
  tenantSlug: string | null;
  receiptAvailable: boolean;
}

export function CompletionScreen({
  email,
  donationId,
  tenantSlug,
  receiptAvailable,
}: CompletionScreenProps) {
  const t = useTranslations('register');
  const tDonate = useTranslations('donate');

  return (
    <div className="flex flex-1 items-center justify-center">
      <div className="w-full rounded-xl border border-emerald-500/30 bg-emerald-500/10 p-6">
        <div className="flex flex-col items-center gap-4 py-6 text-center">
          <div className="flex h-14 w-14 items-center justify-center rounded-full bg-emerald-500/20">
            <CheckCircle2 className="h-7 w-7 text-emerald-400" />
          </div>
          <div className="space-y-2">
            <h1 className="text-3xl font-bold text-white">{t('registrationCompleteTitle')}</h1>
            <p className="text-stone-300">
              {t('registrationCompleteDescriptionDgd', {
                email,
              })}
            </p>
          </div>
          <div className="flex gap-3 justify-center">
            {receiptAvailable && tenantSlug && donationId && (
              <Button
                type="button"
                variant="outline"
                className="border-stone-700 bg-stone-900 text-stone-700 hover:bg-stone-800"
                onClick={() =>
                  window.open(`/api/receipts/${tenantSlug}/donations/${donationId}`, '_blank')
                }
              >
                <FileDown className="w-4 h-4 mr-2" />
                {tDonate('form.downloadReceipt')}
              </Button>
            )}
            <Button
              type="button"
              onClick={() => window.location.assign('/my/dashboard')}
              className="bg-dgd-gold text-stone-950 hover:bg-dgd-gold-light"
            >
              {t('goToDashboard')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
